export default __webpack_public_path__ + "static/media/nft.78c72877.svg";